import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as offlineMapsService from '../services/offlineTilesService';

export const fetchUserTiles = createAsyncThunk('offlineTiles/fetchAll', async (_, { rejectWithValue }) => {
	try {
		return await offlineMapsService.fetchUserTiles();
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || error.message || 'Erro ao buscar mapas');
	}
});

export const uploadTile = createAsyncThunk('offlineTiles/upload', async (file, { rejectWithValue }) => {
	try {
		return await offlineMapsService.uploadTile(file);
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || error.message || 'Erro ao fazer upload');
	}
});

export const deleteTile = createAsyncThunk('offlineTiles/delete', async (tileId, { rejectWithValue }) => {
	try {
		await offlineMapsService.deleteTile(tileId);
		return tileId;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || error.message || 'Erro ao deletar mapa');
	}
});

const initialState = {
	list: [],
	loading: false,
	uploading: false,
	deleting: false,
	errorFetch: null,
	errorUpload: null,
	errorDelete: null,
	selectedFile: null
};

const offlineMapsSlice = createSlice({
	name: 'offlineTiles',
	initialState,
	reducers: {
		setSelectedFile: (state, action) => {
			state.selectedFile = action.payload;
		},
		clearSelectedFile: (state) => {
			state.selectedFile = null;
		},
		clearError: (state) => {
			state.errorFetch = null;
			state.errorUpload = null;
			state.errorDelete = null;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchUserTiles.pending, (state) => {
				state.loading = true;
				state.errorFetch = null;
			})
			.addCase(fetchUserTiles.fulfilled, (state, action) => {
				state.loading = false;
				state.list = action.payload;
			})
			.addCase(fetchUserTiles.rejected, (state, action) => {
				state.loading = false;
				state.errorFetch = action.payload;
			});

		builder
			.addCase(uploadTile.pending, (state) => {
				state.uploading = true;
				state.errorUpload = null;
			})
			.addCase(uploadTile.fulfilled, (state, action) => {
				state.uploading = false;
				state.list.unshift(action.payload);
				state.selectedFile = null;
			})
			.addCase(uploadTile.rejected, (state, action) => {
				state.uploading = false;
				state.errorUpload = action.payload;
			});

		builder
			.addCase(deleteTile.pending, (state) => {
				state.deleting = true;
				state.errorDelete = null;
			})
			.addCase(deleteTile.fulfilled, (state, action) => {
				state.deleting = false;
				state.list = state.list.filter((item) => item.id !== action.payload);
			})
			.addCase(deleteTile.rejected, (state, action) => {
				state.deleting = false;
				state.errorDelete = action.payload;
			});
	}
});

export const { setSelectedFile, clearSelectedFile, clearError } = offlineMapsSlice.actions;
export default offlineMapsSlice.reducer;
